import { dataProvider } from "@/@core/http";

export const reuploadPages = async domainId => {
  const { data } = await dataProvider.customHttpCall("POST", `domains/${domainId}/reupload`, []);

  return data;
};
